// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-schema_info',
    // #endregion
    // #region Properties
    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        schema: {
            type: Object,
            required: false,
            default: {}
        },
    },
    data: () => ({
        elements: [],
        isLoading: false,
        _page: undefined,
        _schema: undefined,
        _data: {}
    }),
    // #endregion
    // #region Constructor
    async beforeMount() {
        this.load();
    },
    // #endregion
    // #region Methods
    methods: {
        async load() {
            this.isLoading = true;
            //Create 
            let tData = await this.$host.api.get('/forms/schemas/' + this.schema.name + '/' + this.schema.version, { params: { mode: 'info' } });
            if (tData.data) {
                this._schema = tData.data;
                this._page = this._schema.pages && this._schema.pages.length > 0 ? this._schema.pages[0] : null;
            }
            this.isLoading = false;
        },
    },
    //#endregion
});
// #endregion
